/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/UIGroupButton")
UIGLabelButton = xClass("UIGLabelButton", UIGroupButton,function (node) {
    return node
})
UIGLabelButton.prototype.setString = function (str) {
    let self = this
    let bg = self.getChildByName("normal")
    let bgSize = bg.getContentSize()
    let xOffset = 0
    let yOffset = 0
    let rate = 3 / 5
    let label = self.getChildByName("label")
    if (label instanceof ccui.LabelBMFont) {
        [bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
        yOffset = 1
    }else {
        rate = 2 / 5
    }
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    let size = label.getVirtualRendererSize()
    let scale = label.getScale()
    label.setPosition(cc.p(bg.getPositionX() + (bgSize.width - size.width * scale) / 2 + xOffset, bg.getPositionY() - (bgSize.height - size.height * scale) * rate - yOffset))
}
UIGLabelButton.prototype.setGroupContentSize = function (size) {
    let self = this
    self.setContentSize(size.width, size.height + 1)
    self.getChildByName("normal").setContentSize(size)
    self.getChildByName("click").setContentSize(size)
    self.getChildByName("disabled").setContentSize(size)

    let str = self.getChildByName("label").getString()
    self.setString(str)
}